import { memo } from 'react';
import styles from './LinkStyleButton.module.css';

interface LinkStyleButtonProps {
  text: string;
  onClick: () => void;
}

function LinkStyleButton({ text, onClick }: LinkStyleButtonProps) {
  return (
    <span className={styles.link} onClick={onClick}>
      {text}
    </span>
  );
}

export default memo(LinkStyleButton);
